import requestFunctions from "../../functions/requestFunctions";


export const state = {
  BOTS_INTEGRATIONS_ITEM: {},
  BOTS_INTEGRATIONS_LIST: [],
  BOTS_INTEGRATIONS_TABLE_DATA: [],
  BOTS_INTEGRATIONS_LIST_DATA: [],
  BOTS_INTEGRATIONS_TOTAL_ROWS: 0
}

export const getters = {
  GET_BOTS_INTEGRATIONS_ITEM: (state) => {
    return state.BOTS_INTEGRATIONS_ITEM;
  },
  GET_BOTS_INTEGRATIONS_LIST: (state) => {
    return state.BOTS_INTEGRATIONS_LIST;
  },
  GET_BOTS_INTEGRATIONS_TABLE_DATA: (state) => {
    return state.BOTS_INTEGRATIONS_TABLE_DATA;
  },
  GET_BOTS_INTEGRATIONS_LIST_DATA: (state) => {
    return state.BOTS_INTEGRATIONS_LIST_DATA;
  },
  GET_BOTS_INTEGRATIONS_TOTAL_ROWS: (state) => {
    return state.BOTS_INTEGRATIONS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_BOTS_INTEGRATIONS_ITEM(state, item) {
    state.BOTS_INTEGRATIONS_ITEM = item;
  },

  UPDATE_BOTS_INTEGRATIONS_LIST(state, list) {
    
    state.BOTS_INTEGRATIONS_LIST = list.data;

    state.BOTS_INTEGRATIONS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.BOTS_INTEGRATIONS_TABLE_DATA = [];
    state.BOTS_INTEGRATIONS_LIST_DATA = [];

    list.forEach(el => {

      state.BOTS_INTEGRATIONS_TABLE_DATA.push({
        'name' : el.name,
        'uuid' : el.uuid
      });

      state.BOTS_INTEGRATIONS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_BOTS_INTEGRATIONS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/integrations/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_INTEGRATIONS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_INTEGRATIONS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/integrations';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_INTEGRATIONS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_INTEGRATIONS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/integrations';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_INTEGRATIONS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/integrations/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_INTEGRATIONS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/integrations/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}